import axiosInstance from "./api";
import TokenService from "./tokenService";
import AuthService from "./authService";
import router from "../router";

const setup = (store: any) => {
  axiosInstance.interceptors.request.use(
    (config: any) => {
      const token = TokenService.getLocalAccessToken();
      if (token) {
        config.headers["Authorization"] = "Bearer " + token;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
    (res) => {
      return res;
    },
    async (err) => {
      // Prevent loop
      if (err.config.url === "/login/refresh") return Promise.reject(err);

      const originalConfig = err.config;

      if (originalConfig.url !== "/login" && err.response) {
        // Access Token was expired
        if (err.response.status === 401 && !originalConfig._retry) {
          originalConfig._retry = true;

          // Refresh access token
          try {
            const rs = await axiosInstance.get("/login/refresh", {
              params: {
                refreshToken: TokenService.getLocalRefreshToken(),
              },
            });

            const accessToken = rs.data;

            store.dispatch("auth/refreshToken", accessToken);
            TokenService.updateLocalAccessToken(accessToken);

            return axiosInstance(originalConfig);
          } catch (_error) {
            // If Refresh token was expired
            const currentRoute = router.currentRoute.value.fullPath;
            store.dispatch("auth/rememberPath", currentRoute);
            AuthService.logout();
            return Promise.reject(_error);
          }
        }
      }

      return Promise.reject(err);
    }
  );
};

export default setup;
